<template>
  <st-scrolly :dontUseSticky="false">
    <template v-slot:background="{slideIndex, enter}">
      <div class="scrolly-content">
        <scrolly-svg v-if="!attributes.mode || attributes.mode ==='svg'"
          :rootFolder="attributes.value"
          :index="slideIndex + 1"/>
        <scrolly-image v-else-if="attributes.mode === 'image'"
          :attributes="attributes"
          :enter="enter"/>
      </div>
    </template>

    <div class="slide" :style="slideStyle(i)" v-for="(slideText, i) in attributes.p" :key="i">
      <div class="slide-content">
        <img v-if="attributes.thumbnail && attributes.thumbnail[i]" :src="require(`images/${attributes.thumbnail[i]}`)">
        <p v-markdown="slideText"></p>
      </div>
    </div>
  </st-scrolly>
</template>

<script>

// https://github.com/yongjun21/st-scrolly/blob/master/packages/%40st-graphics/scrolly/src/index.vue
import StScrolly from '@st-graphics/scrolly'
import '@st-graphics/scrolly/dist/bundle.css'

import ScrollyImage from './ScrollyImage.vue'
import ScrollySvg from './ScrollySvg.vue'

export default {
  name: 'Scrolly',
  props: ['attributes'],
  data () {
    return {
      initHeight: this.$window.innerHeight
    }
  },
  components: {
    StScrolly,
    ScrollyImage,
    ScrollySvg
  },
  computed: {
    slideHeight () {
      return this.initHeight < 800 ? 800 : this.initHeight
    }
  },
  methods: {
    slideStyle (i) {
      const isLast = i === this.attributes.p.length - 1

      return {
        paddingTop: `${this.slideHeight}px`,
        paddingBottom: isLast ? `${this.slideHeight}px` : 0
      }
    }
  }
}
</script>

<style lang="scss">
.component.component-scrolly .component-content {
  &.container {
    .background,
    .foreground {
      max-width: 1200px;
    }
  }

  &.inline {
    .background,
    .foreground {
      max-width: 700px;
    }
  }

  &.spread {
    .background,
    .foreground {
      max-width: 700px;

      @include breakpoint($d_normal) {
        max-width: 860px;
      }
    }
  }
}

.st-scrolly {
  .background-container {
    .background,
    .foreground {
      & > * {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: auto;
        width: 100%;
        height: 100%;
      }
    }
  }

  .slide-container {
    @include container;

    .slide {
      .slide-content {
        display: inline-block;
        background-color: #FFFFFF;
        max-width: 400px;
        margin: 0 $outerSpacingMobile;

        @include breakpoint($d_medium) {
          margin: 0 $outerSpacing;
        }

        img {
          display: block;
          width: 100%;
        }

        p {
          font-size: 20px;
          line-height: 31px;
          color: $black;
          padding: 10px 15px 20px;

          @include breakpoint($d_medium) {
            font-size: 22px;
          }

          &:only-child {
            padding: 15px 15px 20px;
          }
        }
      }
    }
  }
}
</style>
